import Vue from 'vue';
import { Checkbox } from 'element-ui';

function resetSelector(vm: Vue) {
    vm.$data.scope.select = null;
    vm.$emit('selectorChange', vm.$data.scope.select);
}

/**
 * 此marco提供一个互斥的checkbox列,同一时间只能选中一个  
 * 选中时会携当前选中项触发selectorChange事件
 */
export function macroMutexSelector(vm: Vue, h: any) {
    vm.$set(vm.$data.scope, 'select', null);
    (vm as any).addEvent(vm, () => resetSelector(vm));

    const scopedSlots = {
        default: function (body) {
            return <Checkbox {...{
                attrs: {
                    value: vm.$data.scope.select === body.row,
                },
                on: {
                    input: (checked) => {
                        if (checked) {
                            vm.$data.scope.select = body.row;
                        }
                        else {
                            vm.$data.scope.select = null;
                        }

                        vm.$emit('selectorChange', vm.$data.scope.select);
                    }
                },
            }}></Checkbox>
        },
        header: function () {
            return <span></span>
        }
    }

    return <colDefiner {...{ scopedSlots }}></colDefiner>;
}